import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminRoutingModule } from './admin-routing.module';
import { NewDashboardComponent } from '../admin/new-dashboard/new-dashboard.component';
import { BookingsComponent } from '../admin/bookings/bookings.component';
import { AdminMembersAnalyticsComponent } from '../admin/admin-members-analytics/admin-members-analytics.component';
import { AdminManageChatAIComponent } from '../admin/admin-manage-chat-ai/admin-manage-chat-ai.component';
import { AdminManageSurveyComponent } from '../admin/admin-manage-survey/admin-manage-survey.component';
import { AdminForumCategoriesComponent } from '../admin/admin-forum-categories/admin-forum-categories.component';
import { AdminForumPollingComponent } from '../admin/admin-forum-polling/admin-forum-polling.component';
import { AdminForumGiveawayComponent } from '../admin/admin-forum-giveaway/admin-forum-giveaway.component';
import { AdminForumGiveawayDetailComponent } from '../admin/admin-forum-giveaway/forum-giveaway-detail/forum-giveaway-detail.component';
import { SuperAdminComponent } from '../admin/super-admin/super-admin.component';
import { QuestsComponent } from '../admin/super-admin/quests/quests.component';
import { MapSearchComponent } from '../admin/map-search/map-search.component';
import { AdminMarketComponent } from '../admin/admin-market/admin-market.component';
import { AdminMarketBlogComponent } from '../admin/admin-market-blog/admin-market-blog.component';
import { CampaignComponent } from '../admin/campaign/campaign.component';
import { SubadminOrdersComponent } from '../admin/subadmin-orders/subadmin-orders.component';
import { SubAdminVoucherComponent } from '../admin/sub-admin/voucher-cashback/voucher/voucher.component';
import { SubAdminCashbackComponent } from '../admin/sub-admin/voucher-cashback/cashback/cashback.component';
import { SubAdminGalleryComponent } from '../admin/sub-admin/voucher-cashback/gallery/gallery.component';
import { SubAdminNewsComponent } from '../admin/sub-admin/voucher-cashback/news/news.component';
import { ManageBrandsComponent } from '../admin/admin-market/manage-brands/manage-brands.component';
import { ShopSummaryComponent } from '../admin/shop-summary/shop-summary.component';
import { ManageMemberRolesComponent } from '../admin/manage-member-roles/manage-member-roles.component';
import { ManualReviewsTwoComponent } from '../admin/manual-reviews-two/manual-reviews-two.component';
import { ManualReviewsThreeComponent } from '../admin/manual-reviews-three/manual-reviews-three.component';
import { ReviewPendingCompleteAdditionalComponent } from '../admin/review-pending-complete-additional/review-pending-complete-additional.component';
import { FeedbackManagerSubComponent } from '../admin/sub-admin/feedback-manager-sub/feedback-manager-sub.component';
import { AddFeedbackManagerSubComponent } from '../admin/sub-admin/add-feedback-manager-sub/add-feedback-manager-sub.component';
import { NewPurchaseUpgradesComponent } from '../admin/new-purchase-upgrades/new-purchase-upgrades.component';
import { NewReviewsComponent } from '../admin/new-reviews/new-reviews.component';
import { NewFeedbackUrlComponent } from '../admin/new-feedback-url/new-feedback-url.component';
import { GoogleReviewsComponent } from '../admin/google-reviews/google-reviews.component';
import { InstagramReviewsComponent } from '../admin/instagram-reviews/instagram-reviews.component';
import { TwitterReviewsComponent } from '../admin/twitter-reviews/twitter-reviews.component';
import { OurFeaturesFirstComponent } from '../admin/our-features-first/our-features-first.component';
import { OurFeaturesSecondComponent } from '../admin/our-features-second/our-features-second.component';
import { OurFeaturesThirdComponent } from '../admin/our-features-third/our-features-third.component';
import { NewEditProfileComponent } from '../admin/new-edit-profile/new-edit-profile.component';
import { NewSubAdminsComponent } from '../admin/new-sub-admins/new-sub-admins.component';
import { NewSubAdminsSubscription } from '../admin/new-sub-admins-subscription/new-sub-admins.component';
import { NewSubAdminsTransactions } from '../admin/new-sub-admins-transactions/new-sub-admins.component';
import { NewSubAdminsDiamondTransactions } from '../admin/new-sub-admins-diamond-transactions/new-sub-admins.component';
import { NewSubAdminsRentalAuth } from '../admin/new-sub-admins-rental-auth/new-sub-admins.component';
import { NewSubAdminsUsersAuth } from '../admin/new-sub-admins-users-auth/new-sub-admins.component';
import { NewUpdateProfileComponent } from '../admin/new-update-profile/new-update-profile.component';
import { NewPricesAndPackagesComponent } from '../admin/new-prices-and-packages/new-prices-and-packages.component';
import { NewHelpCenterComponent } from '../admin/new-help-center/new-help-center.component';
import { NewOurFeaturesComponent } from '../admin/new-our-features/new-our-features.component';
import { ReviewPendingCompleteComponent } from '../admin/review-pending-complete/review-pending-complete.component';
import { NewReviewInfoComponent } from '../admin/new-review-info/new-review-info.component';
import { NewNameComponent } from '../admin/new-name/new-name.component';
import { MassMessagingComponent } from '../admin/mass-messaging/mass-messaging.component';
import { ShareModule } from '../shareModule/shareModule';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClosingListingComponent } from '../admin/sub-admin/closing-listing/closing-listing.component';
import { HomeButtonsComponent } from '../admin/sub-admin/home-buttons/home-buttons.component';
import { SubadminSearchComponent } from '../admin/sub-admin/subadmin-search/subadmin-search.component';
import { AllSaveValuesComponent } from '../admin/sub-admin/all-save-values/all-save-values.component';
import { MemberCertificateComponent } from '../admin/admin-market/member-certificate/member-certificate.component';
import { MemberKeywordsComponent } from '../admin/admin-market/member-keywords/member-keywords.component';
import { AssignToLevelComponent } from '../admin/manage-member-roles/assign-to-level/assign-to-level.component';
import { AssignToUsersComponent } from '../admin/manage-member-roles/assign-to-users/assign-to-users.component';
import { HomeBannerComponent } from '../admin/auth/home-banner/home-banner.component';
import { HomeServiceComponent } from '../admin/auth/home-service/home-service.component';
import { HomeAboutComponent } from '../admin/auth/home-about/home-about.component';
import { HomeClientComponent } from '../admin/auth/home-client/home-client.component';
import { HomeSearchComponent } from '../admin/auth/home-search/home-search.component';

import { AddNotesComponent } from '../admin/auth/add-notes/add-notes.component';
import { SubAdminsComponent } from '../admin/auth/sub-admins/sub-admins.component';

import { SearchModalComponent } from '../admin/sub-admin/search-modal/search-modal.component';
import { MemberSignupModalComponent } from '../admin/sub-admin/member-signup-modal/member-signup-modal.component';

import { CharIconsComponent } from '../admin/auth/char-icons/char-icons.component';
import { HomeTopBannerComponent } from '../admin/auth/home-top-banner/home-top-banner.component';
import { HomeVisitStoreComponent } from '../admin/auth/home-visit-store/home-visit-store.component';
import { NewCustomerComponent } from '../admin/sub-admin/new-customer/new-customer.component';
import { FeedbackCardComponent } from '../admin/auth/feedback-card/feedback-card.component';
import { RepairCompltedListComponent } from '../admin/sub-admin/repair-complted-list/repair-complted-list.component';
import { SmsSectionComponent } from '../admin/sub-admin/sms-section/sms-section.component';
import { CustomerLoginModalComponent } from '../admin/auth/customer-login-modal/customer-login-modal.component';
import { BottomBannerComponent } from '../admin/sub-admin/bottom-banner/bottom-banner.component';
import { GuestLoginComponent } from '../admin/sub-admin/guest-login/guest-login.component';
import { GuestHeaderComponent } from '../admin/sub-admin/guest-header/guest-header.component';
import { GuestFooterComponent } from '../admin/auth/guest-footer/guest-footer.component';
import { FeedbackCommonComponent } from '../admin/sub-admin/feedback-common/feedback-common.component';
import { NewLoginModalComponent } from '../admin/new-login-modal/new-login-modal.component';
import { NewSignupModalComponent } from '../admin/new-signup-modal/new-signup-modal.component';
import { NewForgotPasswordComponent } from '../admin/new-forgot-password/new-forgot-password.component';
import { NewResetPasswordComponent } from '../admin/new-reset-password/new-reset-password.component';
import { NewChangePasswordComponent } from '../admin/new-change-password/new-change-password.component';
import { NewTransactionListingComponent } from '../admin/new-transaction-listing/new-transaction-listing.component';
import { NewGoogleReviewsComponent } from '../admin/new-google-reviews/new-google-reviews.component';
import { GoogleReviewModalComponent } from '../admin/google-review-modal/google-review-modal.component';
import { NewBulkCustomerEmailComponent } from '../admin/new-bulk-customer-email/new-bulk-customer-email.component';
import { PoliciesComponent } from '../customers/policies/policies.component';
import { AssignToCharacterComponent } from './manage-member-roles/assign-to-character/assign-to-character.component';
import { MemberSurveyComponent } from './admin-market/member-survey/member-survey.component';
import { Chart, registerables } from 'chart.js';
import { ManageSubRegionComponent } from './admin-market/manage-sub-region/manage-sub-region.component';
import { ActivityLogComponent } from './sub-admin/activity-log/activity-log.component';
import { PaymentComponent } from './payment/payment.component';
import { FaqComponent } from './faq/faq.component';
import { BizTelegramComponent } from './biz-telegram/biz-telegram.component';
import { BizMessagesComponent } from './biz-messages/biz-messages.component';
import { AdminAdComponent } from './admin-ad/admin-ad.component';
import { AdminStatsComponent } from './admin-stats/admin-stats.component';

Chart.register(...registerables);
@NgModule({
  declarations: [
    AdminStatsComponent,
    AdminAdComponent,
    PoliciesComponent,
    NewDashboardComponent,
    ReviewPendingCompleteAdditionalComponent,
    ManualReviewsThreeComponent,
    ManualReviewsTwoComponent,
    ManageMemberRolesComponent,
    ShopSummaryComponent,
    SubadminOrdersComponent,
    SubAdminVoucherComponent,
    SubAdminCashbackComponent,
    SubAdminNewsComponent,
    ManageBrandsComponent,
    SubAdminGalleryComponent,
    CampaignComponent,
    AdminMarketBlogComponent,
    AdminMarketComponent,
    MapSearchComponent,
    QuestsComponent,
    SuperAdminComponent,
    AdminForumGiveawayComponent,
    AdminForumGiveawayDetailComponent,
    AdminForumPollingComponent,
    AdminForumCategoriesComponent,
    AdminManageChatAIComponent,
    AdminManageSurveyComponent,
    AdminMembersAnalyticsComponent,
    BookingsComponent,
    MassMessagingComponent,
    NewNameComponent,
    NewReviewInfoComponent,
    ReviewPendingCompleteComponent,
    NewOurFeaturesComponent,
    NewHelpCenterComponent,
    NewPricesAndPackagesComponent,
    NewUpdateProfileComponent,
    NewSubAdminsDiamondTransactions,
    NewSubAdminsRentalAuth,
    NewSubAdminsUsersAuth,
    NewSubAdminsTransactions,
    NewSubAdminsSubscription,
    NewSubAdminsComponent,
    BizMessagesComponent,
    NewEditProfileComponent,
    OurFeaturesThirdComponent,
    OurFeaturesSecondComponent,
    OurFeaturesFirstComponent,
    TwitterReviewsComponent,
    InstagramReviewsComponent,
    GoogleReviewsComponent,
    NewFeedbackUrlComponent,
    NewReviewsComponent,
    NewPurchaseUpgradesComponent,
    AddFeedbackManagerSubComponent,
    FeedbackManagerSubComponent,
    ClosingListingComponent,
    HomeButtonsComponent,
    SubadminSearchComponent,
    AllSaveValuesComponent,
    MemberCertificateComponent,
    MemberKeywordsComponent,
    AssignToLevelComponent,
    AssignToUsersComponent,

    HomeBannerComponent,
    HomeServiceComponent,
    HomeAboutComponent,
    HomeClientComponent,
    HomeSearchComponent,
    AddNotesComponent,
    SubAdminsComponent,
    SearchModalComponent,
    MemberSignupModalComponent,
    CharIconsComponent,
    HomeTopBannerComponent,
    HomeVisitStoreComponent,
    NewCustomerComponent,
    FeedbackCardComponent,
    RepairCompltedListComponent,
    SmsSectionComponent,
    CustomerLoginModalComponent,
    BottomBannerComponent,
    GuestLoginComponent,
    GuestHeaderComponent,
    GuestFooterComponent,
    FeedbackCommonComponent,
    NewLoginModalComponent,
    NewSignupModalComponent,
    NewForgotPasswordComponent,
    NewResetPasswordComponent,
    NewChangePasswordComponent,
    NewTransactionListingComponent,
    NewGoogleReviewsComponent,
    GoogleReviewModalComponent,
    NewBulkCustomerEmailComponent,
    AssignToCharacterComponent,
    MemberSurveyComponent,
    ManageSubRegionComponent,
    ActivityLogComponent,
    PaymentComponent,
    FaqComponent,
    BizTelegramComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    AdminRoutingModule,
    ShareModule,
    CommonModule,
  ],
  exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AdminModule { }
